module.exports = {
    "dismiss": `\u{95DC}\u{9589}`
};


//# sourceMappingURL=zh-TW.main.js.map
